import type { Animation } from '@adflow/types';
import type { EditorState } from '@adflow/types';

import type { CanvasDocumentState } from './documentModel';

export function documentStateFromElements(
  elements: EditorState['elements'],
  animation: Animation | null,
  hierarchy: CanvasDocumentState['hierarchy'] = null,
): CanvasDocumentState {
  return {
    elements: elements.map((element) => ({
      id: element.id,
      x: element.position.x,
      y: element.position.y,
      z: element.position.z,
    })),
    animation,
    hierarchy,
  };
}
